<div class="flex flex-col flex-1 justify-center items-center">
	<div class="empty-state-image">
		<img src="assets/images/empty-states/mortgages.svg" class="max-w-500" />
	</div>
	<h3 class="mt-10">Writ search not yet completed</h3>
	<p class="mt-3">Looks like you haven't completed a writ search yet.</p>
	<div class="mt-5" *ngIf="!hideButton">
		<app-button [icon]="ICON.SEARCH" size="small" (click)="searchForWritClick()"
			>Search for a writ</app-button
		>
	</div>
</div>
